import { useCompanyEditPageProps } from "@/pages/company-edit/fetch";
import { CompanyEditPageUi } from "@/pages/company-edit/ui";

type Props = {
  companyId: number;
  isXmileSystemAdmin: boolean;
};

export const CompanyEditPage = ({ companyId, isXmileSystemAdmin }: Props) => {
  const props = useCompanyEditPageProps({ companyId, isXmileSystemAdmin });

  return <CompanyEditPageUi {...props} />;
};
